export const ErrorMessage = {
  _GENERIC: '🧐 Oops, looks like something went wrong on our side, we’re on it!',
  NO_PRODUCT: '🧐 Oops, looks like something went wrong with your workspace, try again later or contact du support',
  SERVER_UNAVAILABLE: 'Server temporary unavailable, please try again later',
  UNAUTHORIZED: '🤭 It seems that you do not have the required authorization',
};
